import { forwardRef, useImperativeHandle, useRef } from "react"
import PropTypes from "prop-types"
import HCaptcha from "@hcaptcha/react-hcaptcha"
import "./style.scss"

const Captcha = forwardRef(({ onVerify, siteKey }, ref) => {
  const captchaRef = useRef(null)

  useImperativeHandle(ref, () => ({
    /**
     * Resets the captcha component. This method should be called after each successful verification because verification responses can only be used once.
     */
    reset() {
      captchaRef.current.resetCaptcha()
    },
  }))

  return <div className="captcha-container">
    <HCaptcha
      id="captcha-component"
      sitekey={siteKey}
      onVerify={onVerify}
      ref={captchaRef}
    />
  </div>
})

Captcha.displayName = "Captcha"

Captcha.propTypes = {
  onVerify: PropTypes.func.isRequired,
  siteKey: PropTypes.string.isRequired,
}

export default Captcha
